<ub-card [rounded]="true">
  <h1 title i18n>Users</h1>
  <div actions>
    <eas-buttons-list [buttons]="actions"></eas-buttons-list>
  </div>
  <div content>
    <eas-interactive-table [options]="tableComponentOptions" (selectedItems)="onSelectedItems($event)"></eas-interactive-table>
    @if (selectedItems.total > 0) {
      <div class="actions-footer">
        <ub-label text="{{selectedItems.total}} {{selectedItems.total === 1 ? 'user' : 'users'}} selected" variant="none" i18n-label i18n-text></ub-label>
        <button mat-flat-button color="primary" type="button" (click)="doBulkAction()" i18n>
          Bulk action
        </button>
      </div>
    }
  </div>
</ub-card>
